import store from '@/store'
import { Entity } from '@/store/entity'

export class Experience extends Entity {
  get partner() {
    const partner = store.getters['partner/getPartner']

    if (!partner) {
      store.dispatch('partner/fetchPartner')
    }

    return partner
  }

  get refundFormatted() {
    return this.formatCurrency(this.refund);
  }

  get creditFormatted() {
    if (!this.credit || this.credit === '') {
      return '';
    }

    return this.formatCurrency(this.credit);
  }
}
